import { render } from "./MeatandCheese.vue?vue&type=template&id=0a1791ee&scoped=true"
import script from "./MeatandCheese.vue?vue&type=script&lang=js"
export * from "./MeatandCheese.vue?vue&type=script&lang=js"

import "./MeatandCheese.vue?vue&type=style&index=0&id=0a1791ee&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a1791ee"]])

export default __exports__